module.exports = __webpack_public_path__ + "img/Травмы, повреждения сухожильно-капсульного аппарата.b70ef964.jpg";